import React from 'react';
import PaddingBox from '@uds/padding-box';
import { Glyph } from '@uds/glyphs';
import { Heading04, BodyCopy } from '@uds/typography';
import { Colorway, cssTheme } from '@uds/theme-utils';
import { Alignment } from 'domain/constants/alignment';
import Shortcode, { ShortcodeProps } from 'components/Shortcode';
import { isNilOrEmpty } from 'presentation/utils/generalUtils';

import getClassNames from './Aspect.stylesheet';

export type AspectType = {
  title: ShortcodeProps;
  body: ShortcodeProps;
};
export interface OuterProps extends AspectType {
  hBaseline: number;
  ticks: boolean;
  colorway: Colorway;
  alignment: Alignment;
}

export const PureAspect = ({ hBaseline = 1, title, body, ticks, colorway, alignment }: OuterProps) => {
  let tickColor;
  if ([Colorway.LIGHT, Colorway.NEUTRAL].includes(colorway)) {
    tickColor = cssTheme.palette.green01;
  }
  const classNames = getClassNames();
  return (
    <PaddingBox>
      <div className={classNames.root} data-alignment={alignment}>
        <Heading04 depth={hBaseline} className={classNames.title} data-alignment={alignment}>
          <>
            <span className={classNames.titleText}>
              <Shortcode code={title} against={colorway} />
            </span>
            {ticks && <Glyph name="tick" alt="tick" className={classNames.tick} color={tickColor} />}
          </>
        </Heading04>
        {!isNilOrEmpty(body) && (
          <BodyCopy>
            <Shortcode code={body} against={colorway} />
          </BodyCopy>
        )}
      </div>
    </PaddingBox>
  );
};

PureAspect.displayName = 'Aspect';

export default PureAspect;
